import { useEffect, useRef } from 'react';

import { useGuidedSearchContext } from './GuidedSearchContext';
import type { IVehicleInfo } from './types';

export const useGuidedSearchVehicleInfo = (
  onVehicleFullySelected?: (info: IVehicleInfo) => void,
) => {
  const { vehicleInfo, updateVehicleInfo, hasTowSelected } = useGuidedSearchContext();
  const pendingApplyRef = useRef<ReturnType<typeof setTimeout>>();

  const cancelPendingApply = () => clearTimeout(pendingApplyRef.current);

  useEffect(() => cancelPendingApply, []);

  // Switching away from Tow must not let a pending tow auto-apply fire.
  useEffect(() => {
    if (!hasTowSelected) cancelPendingApply();
  }, [hasTowSelected]);

  const handleVehicleChange = (newVehicleInfo: IVehicleInfo) => {
    updateVehicleInfo(newVehicleInfo);

    // The latest pick wins: drop any still-pending auto-apply.
    cancelPendingApply();

    // If a model was selected (has modelId and towingCapacity), auto-apply the selection
    if (newVehicleInfo.modelId && newVehicleInfo.towingCapacity) {
      pendingApplyRef.current = setTimeout(() => {
        onVehicleFullySelected?.(newVehicleInfo);
      }, 300);
    }
  };

  const isVehicleFullySelected = !!(vehicleInfo.modelId && vehicleInfo.towingCapacity);

  return { vehicleInfo, handleVehicleChange, isVehicleFullySelected, cancelPendingApply };
};
